import React, { useRef, useMemo, useState, useEffect, useCallback } from "react";
import { Panel } from "rsuite";

import { transformed_service_reverse_data } from "const";
import { usePrevious, useWindowWidth } from "hooks";
import SelfAllocationRestrictions from "./SelfAllocationRestrictions/SelfAllocationRestrictionsContainer";
import TabPaymentManagement from "./TabPaymentManagement/TabPaymentManagementContainer";
import TabPostbackLogsContainer from "./TabPostbackLogs/TabPostbackLogsContainer";
import TabAccessListFilters from "./TabAccessListFilters/TabAccessListFilters";
import TabTransitTrunksContainer from "./Trunks/TabTransitTrunksContainer";
import AccountChanges from "./AccoutChanges/AccountChangesContainer";
import TabGanTrunksContainer from "./Trunks/TabGanTrunksContainer";
import TabTrafficLimits from "./TabTrafficLimits/TabTrafficLimits";
import TabTrunksContainer from "./Trunks/TabTrunksContainer";
import ApiPageContainer from "./ApiPage/ApiPageContainer";
import TabGeneral from "./General/TabGeneral";
import AccountHeader from "./AccountHeader";
import Notes from "./Notes/NotesContainer";
import TabRates from "./Rates/TabRates";

const tabsList = {
    general: "general",
    trunks: "trunks",
    gan_trunks: "gan_trunks",
    transit_trunks: "transit_trunks",
    rates: "rates",
    transit_rates: "transit_rates",
    access: "access",
    supplier_access: "supplier_access",
    traffic_limits: "traffic-limits",
    postback_logs: "postback-logs",
    api: "api",
    self_allocation: "self-allocation",
    payment_management: "payment-management",
    notes: "notes",
    changes: "changes"
};

const isKnownTab = (tab) => {
    return tab && Object.values(tabsList).includes(tab);
};


const Account = ({
    rates,
    match,
    account,
    service,
    history,
    authInfo,
    location,
    e212List,
    ganTrunks,
    role_list,
    accessList,
    setService,
    permissions,
    howFindList,
    redirectTab,
    countryList,
    joinLoading,
    transitRates,
    ratesLoading,
    account_list,
    accountUsers,
    currency_list,
    modifiedLimit,
    supplierTrunks,
    worldzone_list,
    accountLoading,
    accountJoinList,
    currentSupplier,
    admin_role_list,
    transitTrunkList,
    destination_list,
    client_role_list,
    onSetRedirectTab,
    loadingReferences,
    accessListLoading,
    billingServiceList,
    payment_terms_list,
    newCreatedAccountId,
    transitRatesLoading,
    accountUsersLoading,
    subdestination_list,
    account_manager_list,
    accountServicePlanList,
    account_user_modify_method,
    account_user_remove_method,
    payment_terms_supplier_list,

    getRates: getRateList,
    getKeyList,
    getAccount,
    getAccounts,
    getAccountJoin,
    getTransitRates,
    getAccountUsers,
    setResellerMode,
    deletePrice,
    syncSupplierPrice,
    supplierPriceList,
    unsetTrunksInited,
    setModifiedLimitId,
    setCurrentSupplier,
    getAccessListFilter,
    getDropdownAccounts,
    getSupplierPriceList,
    getE212DropdownList,
    setEmptyAccountTrunk,
    getSupplierAccountTrunk,
    getReferencesForReports,
    getAccountServicePlanList,
    setAllocationRestrictions,
    getAccountManagersDropdownList
}) => {
    const tabTrunks = useRef(null);
    const didFetchManagers = useRef(null);

    const storagedActiveTab = localStorage.getItem("ACCOUNT_ACTIVE_TAB");
    const createJoinedAccounts = JSON.parse(localStorage.getItem("CREATE_JOINED_ACCOUNTS") || "[]");
    const isCreateJoined = createJoinedAccounts.includes(String(account.id));

    const supervisorSmsRole = role_list.includes("Supervisor (sms)");
    const isSupervisorSms = role_list && role_list.length ? supervisorSmsRole : null;
    const isSupplier = history.location.pathname.includes("sms-suppliers");

    const serviceTransformed = transformed_service_reverse_data[service];
    const accountJoinSafeList = accountJoinList && accountJoinList.length ? accountJoinList : [];
    const accountByService = accountJoinSafeList.find(account => account.service === serviceTransformed) || {};
    const hasAccountService = !!Object.keys(accountJoinSafeList).length;

    const serviceCompared = serviceTransformed === account.service;

    const prevServiceCompared = usePrevious(serviceCompared);

    const calculateTab = () => {
        const supplierDefaultTab = isSupplier ? tabsList.gan_trunks : tabsList.trunks;
        const compared = serviceCompared && hasAccountService;

        const comparedServiceDefaultTab = compared ? supplierDefaultTab : tabsList.general;
        return comparedServiceDefaultTab;
    };

    const defaultTab = useMemo(() => calculateTab(), [
        isSupplier,
        serviceCompared,
        hasAccountService,
    ]);

    const getRequestedTab = (search) => {
        const sp = new URLSearchParams(search);
        const tabFromUrl = sp.get("tab");
        const afterCreate = sp.get("after_create_service") === "1";

        if (afterCreate) {
            return tabsList.general;
        }

        if (redirectTab) {
            return redirectTab;
        }

        if (isKnownTab(tabFromUrl)) {
            return tabFromUrl;
        }

        if (isKnownTab(storagedActiveTab)) {
            return storagedActiveTab;
        }

        return defaultTab;
    };

    const [activeTab, setActiveTab] = useState(() => getRequestedTab(location.search));

    const accountId = match.params.id;

    const resizedWidth = useWindowWidth();

    const reservedAccountId = useMemo(() => {
        if (isCreateJoined) {
            return accountId;
        }

        return account?.id;
    }, [isCreateJoined, accountId, account]);

    const paymentTermsList = useMemo(() => {
        return isSupplier ? payment_terms_supplier_list : payment_terms_list;
    }, [isSupplier, payment_terms_list, payment_terms_supplier_list]);


    const getRates = useCallback((filter, trunkId = null, priceId = null, page = 1, perPage) => {
        if (trunkId || priceId) {
            getTransitRates(trunkId, priceId, filter, page, perPage);
            return;
        }

        getRateList(accountId, filter, service, page, perPage);
    }, [accountId, service, getRateList, getTransitRates]);


    useEffect(() => {
        if (didFetchManagers.current) return;
        didFetchManagers.current = true;

        getAccountManagersDropdownList({}, true);
    }, [getAccountManagersDropdownList]);

    useEffect(() => {
        const sp = new URLSearchParams(location.search);
        const hasTabInUrl = sp.has("tab");
        const afterCreate = sp.get("after_create_service") === "1";

        if (!hasTabInUrl && !afterCreate && !storagedActiveTab) {
            const calculatedTab = calculateTab();
            setActiveTab(calculatedTab);
        }
    }, [location.search, storagedActiveTab, serviceCompared, hasAccountService, isSupplier]);

    useEffect(() => {
        const savedSupplier = localStorage.getItem(`CURRENT_SUPPLIER_${accountId}`);

        if (savedSupplier) {
            const parsedSupplier = JSON.parse(savedSupplier);
            setCurrentSupplier(parsedSupplier);

            // localStorage.removeItem("CURRENT_SUPPLIER");
        }

        const sp = new URLSearchParams(location.search);

        const afterCreate = sp.get("after_create_service") === "1";
        if (afterCreate) {
            setActiveTab(tabsList.general);

            sp.delete("after_create_service");
            const s = sp.toString();
            history.replace({ ...location, search: s ? `?${s}` : "" });
        }

        if (!redirectTab) {
            const tab = sp.get("tab");
            const isTabExists = isKnownTab(tab);

            if (isTabExists) {
                setActiveTab(tab);
            }
        } else {
            setActiveTab(redirectTab);
        }

        getAccountUsers(accountId);

        const setSupplierCallback = isSupplier ? setCurrentSupplier : null;

        getAccountJoin(accountId, setSupplierCallback);
    }, [accountId, newCreatedAccountId]);

    useEffect(() => {
        if (serviceTransformed === account?.service) {
            getRates();
            getAccountServicePlanList(accountId);

            const storagedActiveTab = localStorage.getItem("ACCOUNT_ACTIVE_TAB");

            if (storagedActiveTab) {
                localStorage.removeItem("ACCOUNT_ACTIVE_TAB");
            }
        }

        // getAccountUsers(accountId);

        // const setSupplierCallback = isSupplier ? setCurrentSupplier : null;

        // getAccountJoin(accountId, setSupplierCallback);
    }, [account.id]);

    useEffect(() => {
        const savedSupplier = localStorage.getItem(`CURRENT_SUPPLIER_${accountId}`);

        if (savedSupplier && savedSupplier !== JSON.stringify(currentSupplier)) {
            const parsedSupplier = JSON.parse(savedSupplier);
            setCurrentSupplier(parsedSupplier);
            // localStorage.removeItem("CURRENT_SUPPLIER");
        }
    }, [currentSupplier]);

    useEffect(() => {
        const storagedActiveTab = localStorage.getItem("ACCOUNT_ACTIVE_TAB");

        if (storagedActiveTab && storagedActiveTab === tabsList.gan_trunks && ganTrunks.length === 0) {
            setActiveTab(tabsList.transit_trunks);
        }
    }, [ganTrunks]);

    const onSelectTab = (activeKey) => {
        setEmptyAccountTrunk();
        unsetTrunksInited();

        const sp = new URLSearchParams(location.search);
        // sp.delete("tab");
        sp.set("tab", activeKey);

        const s = sp.toString();
        history.replace({ ...location, search: s ? `?${s}` : "" });

        setActiveTab(activeKey);
    };

    const getAccess = (filter, page, per_page, sort) => {
        getAccessListFilter(accountId, filter, page, per_page, sort);
    };

    const getApiKeys = () => {
        getKeyList(accountId);
    };

    const isGeneralTabDependencyLoading = loadingReferences || accountLoading || accountUsersLoading;

    const isMobile = resizedWidth < 1200;

    return (
        <Panel style={{ marginTop: 10 }} classPrefix="white-panel">

            <AccountHeader
                service={service}
                activeTab={activeTab}
                onSelect={onSelectTab}
                account={account}
                isMobile={isMobile}
                role_list={role_list}
                isSupplier={isSupplier}
                accountJoinList={accountJoinSafeList}
                serviceCompared={serviceCompared}
                accountByService={accountByService}
                billingServiceList={billingServiceList}
            />

            {
                (() => {
                    switch (activeTab) {
                        case tabsList.general:

                            return <TabGeneral
                                disabled={isGeneralTabDependencyLoading || isCreateJoined}

                                {...{
                                    account,
                                    authInfo,
                                    reservedAccountId,
                                    accountJoinList,
                                    joinLoading,
                                    service,
                                    setService,
                                    isSupplier,
                                    isSupervisorSms,
                                    isCreateJoined,

                                    permissions,
                                    account_list,
                                    currency_list,
                                    payment_terms_list: paymentTermsList,
                                    account_manager_list,
                                    client_role_list,
                                    admin_role_list,
                                    accountUsers,
                                    account_user_modify_method,
                                    account_user_remove_method,
                                    getAccount,
                                    getAccounts,
                                    getAccountJoin,
                                    getDropdownAccounts,
                                    currentSupplier,
                                    onSetRedirectTab,
                                    loading: isGeneralTabDependencyLoading,
                                    getAccountManagersDropdownList,
                                    countryList,
                                    howFindList,
                                    supplierTrunks,
                                    setResellerMode
                                }}

                                getAccountUsers={() => {
                                    getAccountUsers(accountId)
                                }}
                            />;

                        case tabsList.trunks:
                            return <TabTrunksContainer
                                account={account}
                                accountId={accountId}
                                isMobile={isMobile}
                                activeTab={activeTab}
                                isSupervisorSms={isSupervisorSms}
                            />;

                        case tabsList.gan_trunks:
                            return <TabGanTrunksContainer
                                account={account}
                                accountId={accountId}
                                service={service}
                                isMobile={isMobile}
                                activeTab={activeTab}
                                isSupervisorSms={isSupervisorSms}
                                currentSupplier={currentSupplier}
                            />;

                        case tabsList.transit_trunks:
                            return <TabTransitTrunksContainer
                                account={account}
                                accountId={accountId}
                                service={service}
                                isMobile={isMobile}
                                activeTab={activeTab}
                                isSupervisorSms={isSupervisorSms}
                                currentSupplier={currentSupplier}
                            />;

                        case tabsList.rates:
                            return <TabRates
                                isActive={activeTab === "rates"}
                                {...{
                                    rates,
                                    service,
                                    ratesLoading,
                                    currency_list,
                                    worldzone_list,
                                    destination_list,
                                    payment_terms_list: paymentTermsList,
                                    subdestination_list,
                                    accountServicePlanList,
                                    isSupervisorSms
                                }}
                                account={account}
                                getItems={getRates}
                                accountId={accountId}
                            />;

                        case tabsList.transit_rates:
                            return <TabRates
                                isActive={activeTab === "transit_rates"}
                                {...{
                                    rates: transitRates,
                                    ratesLoading: transitRatesLoading,
                                    e212List,
                                    countryList,
                                    currency_list,
                                    worldzone_list,
                                    destination_list,
                                    payment_terms_list: paymentTermsList,
                                    subdestination_list,
                                    accountServicePlanList,
                                    isSupervisorSms,
                                    deletePrice,
                                    transitTrunkList
                                }}
                                isSupplier={isSupplier}
                                account={account}
                                supplierId={currentSupplier?.supplier_id}
                                getItems={getRates}
                                syncSupplierPrice={syncSupplierPrice}
                                supplierPriceList={supplierPriceList}
                                getSupplierPriceList={getSupplierPriceList}
                                getE212DropdownList={getE212DropdownList}
                                getSupplierAccountTrunk={getSupplierAccountTrunk}
                                getReferencesForReports={getReferencesForReports}
                            />;


                        case tabsList.access:
                            return <TabAccessListFilters {...{
                                accessList,
                                accessListLoading
                            }}
                                getItems={getAccess}
                                account_id={accountId}
                            />;

                        case tabsList.traffic_limits:
                            return <TabTrafficLimits
                                currentSupplier={currentSupplier}
                                isSupplier={isSupplier}
                            />;

                        case tabsList.postback_logs:
                            return <TabPostbackLogsContainer
                                account_id={accountId}
                            />;

                        case tabsList.api:
                            return <ApiPageContainer
                                getItems={getApiKeys}
                                account_id={accountId}
                                account={account}
                            />;

                        case tabsList.self_allocation:
                            return <SelfAllocationRestrictions
                                {...{
                                    account,
                                    getAccount,
                                    accountServicePlanList,
                                    loading: isGeneralTabDependencyLoading,
                                    setAllocationRestrictions,
                                    setModifiedLimitId,
                                    modifiedLimit
                                }}
                            />;

                        case tabsList.payment_management:
                            return <TabPaymentManagement
                                accountId={accountId}
                                service={service}
                                isSupplier={isSupplier}
                            />;

                        case tabsList.notes:
                            return <Notes
                                accountId={accountId}
                            />;

                        case tabsList.changes:
                            return <AccountChanges
                                accountId={accountId}
                            />

                        default:
                            return null;
                    }
                })()
            }

        </Panel>
    );
};

export default Account;